import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteStage } from "@/adapters/api";
import { invalidateStageTree, stageKeys } from "../utils/query-keys.ts";
import { useStagesLockedGuard } from "./use-stages-locked-guard.ts";

export function useDeleteStage(constructionId: string | undefined) {
	const queryClient = useQueryClient();
	const guardLocked = useStagesLockedGuard(constructionId);

	return useMutation({
		mutationFn: (stageId: string) => {
			if (!constructionId) throw new Error("missing construction");
			return deleteStage(constructionId, stageId);
		},
		onSuccess: (_result, stageId) => {
			queryClient.removeQueries({
				queryKey: stageKeys.detail(constructionId, stageId),
			});
			return invalidateStageTree(queryClient, constructionId);
		},
		onError: guardLocked,
	});
}
